var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 282,
    viewBox: "0 0 310 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.8712 77.1234C59.7096 94.2851 59.7096 122.11 76.8713 139.271L154.65 217.05L216.798 154.902L216.781 154.885L232.395 139.272C249.556 122.11 249.556 94.2855 232.395 77.1238C215.233 59.9621 187.408 59.9622 170.247 77.1238L154.633 92.7374L139.019 77.1234C121.857 59.9617 94.0329 59.9617 76.8712 77.1234Z",
    fill: "url(#paint0_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.263 64.2506C190.036 64.2655 178.813 68.5559 170.248 77.1218L154.64 92.7296L138.782 76.8714C128.808 66.8972 115.232 62.7199 102.241 64.3395C96.4018 74.4275 97.7989 87.5563 106.432 96.1892L156.493 146.25L156.535 146.208L156.838 146.511L201.533 101.816C211.833 91.5163 211.833 74.8171 201.533 64.5174C201.444 64.4277 201.354 64.3387 201.263 64.2506Z",
    fill: "url(#paint1_linear_0_1)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4559 63.7188C55.5147 81.66 55.5147 110.748 73.4558 128.689L154.767 210.001L219.738 145.03L219.722 145.014L236.046 128.69C253.987 110.749 253.987 81.6609 236.046 63.7198C218.105 45.7786 189.016 45.7786 171.075 63.7198L154.751 80.0437L138.426 63.7188C120.485 45.7777 91.397 45.7777 73.4559 63.7188Z",
    fill: "url(#paint2_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.484 50.2629C191.752 50.2821 180.026 54.7674 171.074 63.7187L154.758 80.0348L138.18 63.4562C127.748 53.0249 113.549 48.6585 99.963 50.3571C93.8597 60.9032 95.3205 74.6275 104.345 83.6523L156.68 135.987L156.724 135.942L157.042 136.26L203.767 89.5347C214.535 78.7671 214.535 61.3095 203.767 50.5419C203.673 50.4481 203.579 50.3551 203.484 50.2629Z",
    fill: "url(#paint3_linear_0_1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.549 129.139L115.76 100.974C116.25 99.6857 117.478 98.7039 118.95 98.7039C120.853 98.7039 122.448 100.177 122.448 102.017C122.448 102.57 122.325 103.122 122.08 103.613L110.298 130.55H122.264V121.96C122.264 119.935 123.859 118.339 125.823 118.339C127.848 118.339 129.443 119.935 129.443 121.96V130.55H132.327C133.984 130.673 135.395 131.962 135.395 133.68C135.395 135.398 133.984 136.871 132.327 136.932H129.443V143.129C129.443 145.154 127.848 146.811 125.823 146.811C123.859 146.811 122.264 145.154 122.264 143.129V136.932H105.39C103.61 136.932 102.199 135.705 102.199 133.618C102.199 132.084 102.812 130.796 103.549 129.139ZM141.602 130.489V115.21C141.602 104.84 146.449 98.7039 156.574 98.7039C166.76 98.7039 171.362 104.84 171.362 115.21V130.489C171.362 140.552 166.453 146.811 156.451 146.811C146.388 146.811 141.602 141.043 141.602 130.489ZM148.904 114.781V130.919C148.904 136.748 150.683 140.307 156.451 140.307C162.219 140.307 164.06 136.871 164.06 130.919V114.781C164.06 108.215 161.851 105.208 156.39 105.208C151.235 105.208 148.904 108.031 148.904 114.781ZM179.289 129.139L191.5 100.974C191.991 99.6857 193.218 98.7039 194.691 98.7039C196.593 98.7039 198.188 100.177 198.188 102.017C198.188 102.57 198.065 103.122 197.82 103.613L186.039 130.55H198.004V121.96C198.004 119.935 199.6 118.339 201.563 118.339C203.588 118.339 205.183 119.935 205.183 121.96V130.55H208.067C209.724 130.673 211.135 131.962 211.135 133.68C211.135 135.398 209.724 136.871 208.067 136.932H205.183V143.129C205.183 145.154 203.588 146.811 201.563 146.811C199.6 146.811 198.004 145.154 198.004 143.129V136.932H181.13C179.35 136.932 177.939 135.705 177.939 133.618C177.939 132.084 178.553 130.796 179.289 129.139Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_1",
    x: 0,
    y: 0.00012207,
    width: 309.266,
    height: 281.05,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32,
    result: "effect1_foregroundBlur_0_1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 78.6054,
    y1: 116.548,
    x2: 234.058,
    y2: 116.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.295069,
    stopColor: "#D42425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9816"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 312.516,
    y1: 94.5364,
    x2: 95.2541,
    y2: 63.6323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D42425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9816"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 75.269,
    y1: 104.934,
    x2: 237.784,
    y2: 104.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.295069,
    stopColor: "#D42425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9816"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 319.791,
    y1: 81.9237,
    x2: 92.6598,
    y2: 49.6157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D42425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9816"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.0ae2892f6ef54a3f07d9da86c9d61ae8.svg";
export { ForwardRef as ReactComponent };